/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileAllegatoDTO
 */
export interface FileAllegatoDTO {
    /**
     * 
     * @type {number}
     * @memberof FileAllegatoDTO
     */
    idFileAllegato?: number;
    /**
     * 
     * @type {string}
     * @memberof FileAllegatoDTO
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the FileAllegatoDTO interface.
 */
export function instanceOfFileAllegatoDTO(value: object): value is FileAllegatoDTO {
    return true;
}

export function FileAllegatoDTOFromJSON(json: any): FileAllegatoDTO {
    return FileAllegatoDTOFromJSONTyped(json, false);
}

export function FileAllegatoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileAllegatoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idFileAllegato': json['idFileAllegato'] == null ? undefined : json['idFileAllegato'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
    };
}

export function FileAllegatoDTOToJSON(json: any): FileAllegatoDTO {
    return FileAllegatoDTOToJSONTyped(json, false);
}

export function FileAllegatoDTOToJSONTyped(value?: FileAllegatoDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idFileAllegato': value['idFileAllegato'],
        'fileName': value['fileName'],
    };
}

